module.exports = __webpack_public_path__ + "img/terapiaW.b826665a.jpg";